@if (data$ | async; as data) {
  <div class="contact-item">
    @if (data.anchorId) {
      <a class="anchor" [id]="data.anchorId">{{ data.title }}</a>
    }
    <h2>{{ data.title }}</h2>
    <p [innerHTML]="data.text | safeHtml">{{ data.text }}</p>
    <div class="contact-item-data">
      @if (data.address) {
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="label">{{ 'aimo.contact.address' | cxTranslate }}</div>
          </div>
          <div class="col-12 col-md-9">
            <div [innerHTML]="data.address">{{ data.address }}</div>
            @if (data.addressLink && data.addressUrl) {
              <div class="mt-2">
                <a [href]="data.addressUrl" target="_blank">{{ data.addressLink }}</a>
              </div>
            }
          </div>
        </div>
      }
      @if (data.serviceHours) {
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="label">{{ 'aimo.contact.serviceHours' | cxTranslate }}</div>
          </div>
          <div class="col-12 col-md-9">
            <div [innerHTML]="data.serviceHours">{{ data.serviceHours }}</div>
          </div>
        </div>
      }
      @if (data.email) {
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="label">{{ 'aimo.contact.email' | cxTranslate }}</div>
          </div>
          <div class="col-12 col-md-9">
            <div [innerHTML]="data.email">{{ data.email }}</div>
          </div>
        </div>
      }
      @if (data.phone) {
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="label">{{ 'aimo.contact.phone' | cxTranslate }}</div>
          </div>
          <div class="col-12 col-md-9">
            <div [innerHTML]="data.phone">{{ data.phone }}</div>
          </div>
        </div>
      }
      @if (isPikatukku() && openingHours$ | async; as openingHours) {
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="label">{{ 'aimo.contact.openingHours' | cxTranslate }}</div>
          </div>
          <div class="col-12 col-md-9">
            @for (hour of openingHours; track hour) {
              @if (data.title.toLowerCase().indexOf(hour.location.toLowerCase()) >= 0) {
                @for (day of hour.days; track day) {
                  <div>
                    <b>{{ 'aimo.calendar.weekday.short.' + day.dayOfWeek | cxTranslate }}</b
                      >:
                      @if (!day.closed) {
                        <span>{{ day.opening_hour }}-{{ day.closing_hour }}</span>
                      }
                      @if (day.closed) {
                        <span>{{ 'aimo.pikatukku.closed' | cxTranslate }}</span>
                      }
                    </div>
                  }
                }
              }
              @if (data.openingHoursException && data.openingHoursExceptionUrl) {
                <div class="mt-2">
                  <a [href]="data.openingHoursExceptionUrl" target="_blank">{{ data.openingHoursException }}</a>
                </div>
              }
            </div>
          </div>
        }
        @if (data.googleMaps) {
          <div class="contact-item-map">
            <iframe
              [src]="data.googleMaps | safeUrl"
              allowfullscreen=""
              loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        }
      </div>
    </div>
  }
